import { RouteObject } from "react-router-dom";
import { RecordNewPayment } from "./components/Create/Create";
import PaymentsLandingPage from "./components/landing/landing";
import PaymentReceiptSuccessPage from "./components/receipt/receipt";
import BulkPaymentCreate from "./components/bulkPayment/create/create";
import BatchDetails from "./components/bulkPayment/batchDetails/batchDetails";
import CheckRegisterLanding from "./components/checkRegister/landing/landing";
import DayEndReconcilationLanding from "./components/dayEndReconcilation/landing/landing";
import DayEndReconcilationDetailsLanding from "./components/dayEndReconcilation/details/landing/landing";
import DetailLandingPage from "./components/dayEndReconcilation/details/drillDownDetails/landing/landing";
import SlipLotsLanding from "./components/slipLots/landing/landing";
import SlipLotDetailsLanding from "./components/slipLots/details/landing/landing";
import PaymentDetailsV2 from "./components/payments/detailsv2/detailsv2";

export interface paymentRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: paymentRoute[];
}

export const paymentRoutes: paymentRoute[] = [
  {
    path: "cx/payments",
    element: <PaymentsLandingPage />,
  },
  {
    path: "cx/payments/create",
    element: <RecordNewPayment />,
  },
  {
    path: "cx/payments/create/:action",
    element: <RecordNewPayment />,
  },
  {
    path: "cx/payments/view/:id",
    element: <PaymentDetailsV2 />,
  },
  {
    path: "cx/payments/success",
    element: <PaymentReceiptSuccessPage />,
  },
  {
    path: "cx/payments/bulk-payment/create",
    element: <BulkPaymentCreate />,
  },
  {
    path: "cx/payments/bulk-payment/details/:id",
    element: <BatchDetails />,
  },
  {
    path: "cx/payments/check-register",
    element: <CheckRegisterLanding />,
  },
  {
    path: "cx/payments/day-end-reconcilation",
    element: <DayEndReconcilationLanding />,
  },
  {
    path: "cx/payments/day-end-reconcilation/view/:id",
    element: <DayEndReconcilationDetailsLanding />,
  },
  {
    path: "cx/payments/day-end-reconcilation/view/:id/:channelId/:channelName/drill-down",
    element: <DetailLandingPage />,
  },
  {
    path: "cx/payments/slip-lots",
    element: <SlipLotsLanding />,
  },
  {
    path: "cx/payments/slip-lots/view/:id",
    element: <SlipLotDetailsLanding />,
  },
];
